import { MDBCheckbox, MDBSelect } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { addIPAddr, getMisc } from '../../../apiclients/streamsapi_bridge';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';

const AddIPAddress = forwardRef(({ onClose, setIsloading, setSuccessMessage, setRerender }, ref) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [addressRang, setaddressRang] = useState([]);
    const [selectedDisplayValue, setSelectedDisplayValue] = useState("/32");
    const { register, handleSubmit, watch, setValue, formState: { errors, isDirty }, setError } = useForm({
        defaultValues: {
            ip_address: "",
            network_prefix: "32",
        }
    })

    useEffect(() => {
        async function getIPAddressRange() {
            const response = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["network_prefix"] }
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const tdata = await response.json();
            console.log(JSON.stringify(tdata));
            if (!tdata) {
                window.alert(`info with id  not found`);
            }
            const addressRange = tdata?.misc?.network_prefix ?? {};

            const reversedArray = Object.entries(addressRange).reverse().map(([key, value]) => ({
                value: key,
                text: value.split(" ")[0],
                secondaryText: value.split(" ").slice(1).join(" ")
            }));

            setaddressRang(reversedArray);

        }
        getIPAddressRange();

    }, []);

    const onsubmit = async (data) => {
        if (isDirty) {
            let update = {
                reqid: 136,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                ip_address: data.ip_address,
                network_prefix: data.network_prefix,
            }
            setIsloading(true);
            console.log("add request for ip :::::: " + JSON.stringify(update));
            let saverep = await addIPAddr(update);
            let saverepeMsg = await saverep.json();
            console.log("Reponse for add  IP address ::::: " + JSON.stringify(saverepeMsg));
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            if (saverepeMsg.status && saverepeMsg.status === "success") {
                setSuccessMessage(saverepeMsg.message);
                setRerender(true);
                onClose();
                // navigate("/securityregistrationlanding", {
                //     state: { tab: "tab1" },
                // });



                // window.location.reload();

            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }

            }
        }

    }

    return (
        <>
            <div className="">
                <strong>{t("IpAddredssRange")}</strong>

                <div className="d-flex mt-2">

                    <input
                        type="text"
                        className="form-control w-90"
                        {...register("ip_address", { required: "IP Address is required" })}

                    />
                    {errors.ip_address && (
                        <p className="text-danger">{errors.ip_address.message}</p>
                    )}
                    {/* <select
                        value={watch("network_prefix")}
                        onChange={(e) =>
                            setValue("network_prefix", e.target.value, { shouldDirty: true })
                        }
                    >
                        {Object.entries(addressRang).map(([key, value]) => (
                            <option key={key} value={key}>
                                {watch("network_prefix") === key
                                    ? value.split(" ")[0] // Show only the prefix for the selected value
                                    : value}
                            </option>
                        ))}
                    </select> */}
                    <div className='ipSelectBox'>

                        <MDBSelect
                            label=" "
                            value={watch("network_prefix")}
                            onChange={(e) => setValue("network_prefix", e.value, { shouldDirty: true })}
                            data={addressRang}
                        />
                    </div>

                    {errors.network_prefix && (
                        <p className="text-danger">{errors.network_prefix.message}</p>
                    )}
                </div>


            </div>
            {/* <div className="mt-2">
                <small><b>Note: </b>You can enter an asterisk in the 3rd input field for wild card.</small></div> */}
            {/* <div className="d-flex   py-3">
                <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Activate is all devices' />
            </div> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>
        </>
    )
});

export default AddIPAddress
